import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { Container as SelectContainer, Label } from '../../../components/Form/Select'
import { Container as SearchInputContainer } from '../../../components/Form/SearchInput'

export const Container = styled.div`
  display: flex;
  border-top: 1px solid #DADADA;
`

export const MainContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: flex-start;
  gap: 10px;
  flex: 1 0 0;
`

export const Main = styled.section`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
`

export const Actions = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;

  ${SearchInputContainer}{
    margin-top: 16px;
  }
`

export const RadioGroup = styled.div`
  display: flex;
  gap: 24px;

  label {
    padding-left: 24px;
  }
`

export const SelectGroup = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  margin: 24px 0 0;

  ${SelectContainer}{
    margin-bottom: 0px;
    flex: 1 0 172px;
  }
  ${Label}{
    display: none;
  }
`

export const BoxButton = styled.div`
  display: flex;
  align-items: center;
`

export const RegistrationButton = styled.button`
  display: flex;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  border: 1px solid #028BB7;
  background: #fff;
  color: #028BB7;
  font-family: 'Open Sans';
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`

export const GoTo = styled(Link)`

`

export const NotFound = styled.div`
  margin: 24px auto 0 auto;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  justify-content: center;
  max-width: 752px;
`
export const NotFoundTitle = styled.h2`
  margin-top: 8px;
  font-family: 'Open Sans';
  font-size: 20px;
  font-weight: 700;
  line-height: normal;
  color: #222;
`

export const NotFoundSubtitle = styled.h3`
  font-family: 'Open Sans';
  font-size: 14px;
  font-weight: 400;
  line-height: normal;
  color: #555;
  text-align: center;
`
